// Footer.jsx

import { useTranslation } from "react-i18next";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function Footer() {
  const { t, i18n } = useTranslation();

  const isAR = i18n.language?.toLowerCase().startsWith("ar");
  const settings = useSiteSettings();

  const F = {
    desc: t(
      "footer.desc",
      "Empowering businesses to manage people, performance, and payroll — all in one place.",
    ),

    sections: [
      { label: t("home", "Home"), path: "#home" },
      { label: t("features", "Features"), path: "/#features" },
      { label: t("services", "Services"), path: "/#services" },
      { label: t("testimonials", "Testimonials"), path: "/#testimonials" },
      { label: t("pricing.badge"), path: "/#pricing" },
      { label: t("faq.title", "FAQ"), path: "/#faq" },
      { label: t("contact", "Contact Us"), path: "/#contact" },
    ],

    socials: [
      { label: t("footer.facebook", "Facebook"), href: settings?.facebook_link || "#" },
      { label: t("footer.linkedin", "LinkedIn"), href: settings?.linkedin_link || "#" },
      { label: t("footer.whatsapp", "WhatsApp"), href: settings?.whatsapp || "#" },
    ],
  };

  return (
    <footer className="bg-primary text-gray-300">
      <div className="mx-auto px-6 py-12 md:px-16">
        <div
          className={`grid grid-cols-1 gap-10 md:grid-cols-2 ${
            isAR ? "text-right" : "text-left"
          }`}
        >
          {/* Left - Logo + Description */}
          <div>
            <a
              href="#home"
              aria-label="Go to homepage"
              className="mb-4 flex items-center gap-2"
            >
              <img
                src="/assets/images/nizam-logo.svg"
                alt="Nizam Logo"
                className="size-6 md:size-10"
              />

              <span className="text-2xl font-semibold text-white">
                {t("footer.brand", "Nizam")}
              </span>
            </a>

            <p className="max-w-sm text-lg leading-6 text-gray-300">{F.desc}</p>
            <p>{settings?.phone}</p>
            <p>{settings?.email}</p>
          </div>

          {/* Right */}
          <div className="grid grid-cols-2 gap-10">
            {/* Sections */}
            <div>
              <h3 className="mb-4 text-sm font-semibold text-white">
                {t("footer.sections", "Sections")}
              </h3>

              <ul className="space-y-2 text-sm">
                {F.sections.map((item, i) => (
                  <li key={i}>
                    <a href={item.path} className="transition hover:text-white">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Social */}
            <div>
              <h3 className="mb-4 text-sm font-semibold text-white">
                {t("footer.social", "Social Media")}
              </h3>

              <ul className="space-y-2 text-sm">
                {F.socials.map((item, i) => (
                  <li key={i}>
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noreferrer"
                      className="transition hover:text-white"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
